import { Component, Inject, OnInit, output } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { SerialNoCellComponent } from '../../table-cell/serial-no-cell.component';
import { ImageCellComponent } from '../../table-cell/img-cell.component';
import { AddToFavouritesResponse } from '../../services/raintree/interfaces/add-to-favourite.interface';
import { AddToFavouritesService } from '../../services/raintree/Transmission/add-to-fav.service';
import { LoaderComponent } from '../../common-component/loader/loader.component';
import { CommonModule } from '@angular/common';
import { DpTableComponent } from '../../common-component/dp-table/dp-table.component';
import { WishlistService } from '../../services/raintree/Transmission/wishlist.service';
import { DpSuccessMessageComponent } from '../../common-component/dp-success-message/dp-success-message.component';

@Component({
  selector: 'app-add-to-favourites',
  standalone: true,
  imports: [LoaderComponent, CommonModule, DpTableComponent, MatDialogModule],
  templateUrl: './add-to-favourites.component.html',
  styleUrl: './add-to-favourites.component.scss',
})
export class AddToFavouritesComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private _addToFavouritesService: AddToFavouritesService,
    private toaster: ToastrService,
    private _wishlistService: WishlistService,
    private _dialogRef: MatDialogRef<AddToFavouritesComponent>
  ) {}

  reachFavWishlists: any = [];
  public displayColumnData: any = [
    {
      id: 'SL_NO',
      name: 'Serial Number',
    },
    {
      id: 'dikshyatri_name',
      name: 'Dikshyarthi Name',
    },
    {
      id: 'guardian_name',
      name: 'Guardian Name',
    },

    {
      id: 'ritwiki_name',
      name: 'Ritwick Name',
    },
    {
      id: 'state_name',
      name: 'State',
    },
    {
      id: 'district_name',
      name: 'district',
    },
    {
      id: 'pin',
      name: 'Pincode',
    },
    {
      id: 'permanent_address',
      name: 'Address',
    },
    {
      id: 'added_on',
      name: 'Added On',
    },
    {
      id: 'image',
      name: '',
    },
  ];
  columnConfs = {
    image: { cssClass: 'img-wid' },
  };
  cellComponentMap = {
    serialNo: SerialNoCellComponent,
    image: ImageCellComponent,
  };
  isLoading: boolean = false;
  ngOnInit(): void {
    this.fetchFavWishlistData();
  }

  fetchFavWishlistData() {
    this.isLoading = true;
    this._addToFavouritesService.getData({ pageNo: 1 }).subscribe({
      next: (response: AddToFavouritesResponse) => {
        this.reachFavWishlists = response.data;
        console.log(this.reachFavWishlists);
        this.isLoading = false;
        if (this.reachFavWishlists.length == 0)
          this.toaster.error('No Data Found');
      },
      error: (error) => {
        this.toaster.error(error);
        this.isLoading = false;
      },
    });
  }

  onCellClick(event: any) {
    this._addToFavouritesService.delData(event.SL_NO).subscribe({
      next: (response: any) => {
        if (!response.error)
          this.dialog.open(DpSuccessMessageComponent, {
            panelClass: 'common-pannel-dialog-container',
            data: {
              mainHeading: `Deleted member data from your touchlist favourites`,
              subHeading: `Your can access all wish-lists from the My Wishlist menu on the Reach Defaulter page `,
              buttonValue: 'Finish',
            },
          });
      },
      error: (error) => {
        this.toaster.error(error);
      },
    });
    this._dialogRef.close(true);
  }
}
